import { render, staticRenderFns } from "./popup-do-doc.vue?vue&type=template&id=47afbbd4&scoped=true"
import script from "./popup-do-doc.vue?vue&type=script&lang=js"
export * from "./popup-do-doc.vue?vue&type=script&lang=js"
import style0 from "./popup-do-doc.vue?vue&type=style&index=0&id=47afbbd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47afbbd4",
  null
  
)

export default component.exports